import useAPI from '@/hooks/useAPI';
import InsuranceRepository from '@/repositories/InsuranceRepository';

const useInsuranceProviders = (enabled = true) => {
  const insuranceRepository = InsuranceRepository();

  return useAPI({
    queryKey: ['getInsuranceProviders'],
    queryFn: async () => {
      return await insuranceRepository.getInsuranceProviders();
    },
    enabled
  });
};

export default useInsuranceProviders;
